import Swiper from 'swiper';
import 'swiper/css';

new Swiper('.features-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 16,
});
